module.exports = __webpack_public_path__ + "485b92ba43322d0991016a13ac4f63c9.svg";